import { ActionsTable } from '@src/entities/ActionPath/ui/components/tables/Actions';
import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { Widget } from '@src/shared/ui/components/Widget';
import React from 'react';

import { Description } from './components/Description';

/**
 * Widget: RemediationActions
 *
 * @TODO Needs description.
 *
 * @param assignments
 * @param initiativeType
 * @param remediationType
 * @param scopeCode
 * @returns {Element}
 * @constructor
 */
export function RemediationActions({ assignments = [], initiativeType = '', remediationType = '', scopeCode = '' }) {
  return (
    <ErrorHandler location="src/widgets/RiskRecords/RemediationActions/RemediationActions.jsx">
      <Widget
        description={
          <Description
            initiativeType={initiativeType || ''}
            remediationType={remediationType || ''}
            scopeCode={scopeCode || ''}
          />
        }
        title="Remediation Actions"
      >
        <ActionsTable rows={assignments || []} />
      </Widget>
    </ErrorHandler>
  );
}
